'use client'

import React from "react";
import { motion, useInView } from 'motion/react'
import { useRef } from 'react'

// 导入图片
import cyclePic from '@/assets/images/cycle.png';
import privateMarketPic from '@/assets/images/private-market.png';
import highQualityPic from '@/assets/images/high-quality.png';
import liquidityPic from '@/assets/images/liquidity.png';
import portalPic from '@/assets/images/portal.png';
import logo1Pic from '@/assets/images/logo1.png';
import primary1Pic from '@/assets/images/primary1.png';
import primary2Pic from '@/assets/images/primary2.png';
import primary3Pic from '@/assets/images/primary3.png';
import figurePic from '@/assets/logos/figure.png';
import superiorNetworkPic from '@/assets/images/superior-network.png';
import efficientStructurePic from '@/assets/images/efficient-structure.png';
import executionExpertisePic from '@/assets/images/execution-expertise.png';
import privateMarketAccessPic from '@/assets/images/private-market-access.png';
import leftPic from '@/assets/images/left.png';
import rightPic from '@/assets/images/right.png';
import headerPic from '@/assets/images/header.png';
import logo3Pic from '@/assets/images/logo3.png';
import newsImgPic from '@/assets/images/news-img.png';

export default function WhyPrivateTech() {

  // const gotoPolarisInvest = ()=>{
  //   window.open('https://invest.polarisagi.com/', '_blank');
  // }
  const startStyle = {opacity: 0}
  const endStyle = {
    opacity: 1,
    ease: 'easeInOut',
  }
  const animationTransition = {
    duration: 2
  }
  const ref0 = useRef(null);
  const isRef0InView = useInView(ref0, {once: true})
  const ref1 = useRef(null);
  const isRef1InView = useInView(ref1, {once: true})
  const ref2 = useRef(null);
  const isRef2InView = useInView(ref2, {once: true})
  const ref3 = useRef(null);
  const isRef3InView = useInView(ref3, {once: true})
  const ref4 = useRef(null);
  const isRef4InView = useInView(ref4, {once: true})
  const ref5 = useRef(null);
  const isRef5InView = useInView(ref5, {once: true})
  const ref6 = useRef(null);
  const isRef6InView = useInView(ref6, {once: true})
  const ref7 = useRef(null);
  const isRef7InView = useInView(ref7, {once: true})

  return (
      <div>
        {/* 私有科技价值 */}
        <motion.section ref={ref0} initial={startStyle} animate={isRef0InView?endStyle:{}} transition={animationTransition} className="relative pb-20 top-[66px] mt-16 bg-white">
          <div className="mx-auto">
            <div className="rounded-xl bg-gradient-to-r p-6 sm:p-12" style={{
              background: `linear-gradient(180deg, #A599FF 0%, #6E66E1 100%)`
            }}>
              <h2 className="text-white text-6xl font-medium mb-4 leading-tight">
                Why Private Tech —
                <br className="hidden sm:block" />
                Innovation meets value creation
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8">
                {/* 左上 */}
                <div className="bg-white/12 backdrop-blur-md rounded-xl flex item-center px-6 overflow-hidden border border-white/20 h-[135px]">
                  <div className="flex items-center">
                    <img
                        src={cyclePic}
                        alt=""
                        className="w-8 h-8 mr-5"
                    />
                    <div>
                      <h3 className="text-white font-semibold mb-1">Early in Growth Cycle</h3>
                      <p className="text-white/80 text-sm">With over 1,565 unicorns valued at $5.2 trillion—and growing—private blue-chip tech companies offer unparalleled growth potential.</p>
                    </div>
                  </div>
                </div>

                {/* 右上 */}
                <div className="bg-white/12 backdrop-blur-md rounded-xl flex item-center px-6 overflow-hidden border border-white/20 h-[135px]">
                  <div className="flex items-center">
                    <img
                        src={privateMarketPic}
                        alt=""
                        className="w-10 h-10 mr-5"
                    />
                    <div>
                      <h3 className="text-white font-semibold mb-1">Shifting Value Creation Towards Private Market</h3>
                      <p className="text-white/80 text-sm">Companies are staying private longer, capturing more value before IPOs and shifting growth from public to private markets.</p>
                    </div>
                  </div>
                </div>

                {/* 左下 */}
                <div className="bg-white/12 backdrop-blur-md rounded-xl flex item-center px-6 overflow-hidden border border-white/20 h-[135px]">
                  <div className="flex items-center">
                    <img
                        src={highQualityPic}
                        alt=""
                        className="w-10 h-10 mr-5"
                    />
                    <div>
                      <h3 className="text-white font-semibold mb-1">Today’s Leaders are High‑quality</h3>
                      <p className="text-white/80 text-sm">AI, fintech, space‑tech, and other disruptive sectors are driving innovation and are accessible only in private markets.</p>
                    </div>
                  </div>
                </div>

                {/* 右下 */}
                <div className="bg-white/12 backdrop-blur-md rounded-xl flex item-center px-6 overflow-hidden border border-white/20 h-[135px]">
                  <div className="flex items-center">
                    <img
                        src={liquidityPic}
                        alt=""
                        className="w-10 h-10 mr-5"
                    />
                    <div>
                      <h3 className="text-white font-semibold mb-1">Greater Market Liquidity</h3>
                      <p className="text-white/80 text-sm">Secondary markets are expanding, providing greater liquidity and real‑time, transparent pricing.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* AI 门户数据 */}
        <motion.section ref={ref1} initial={startStyle} animate={isRef1InView?endStyle:{}} transition={animationTransition} className="pt-20 bg-white">
          <div className="mx-auto px-6 sm:px-8 lg:px-10 text-center flex flex-col item-center">
            <p className="text-[#6E66E1] text-md font-semibold uppercase tracking-wide mb-2">OUR TECHNOLOGY</p>
            <h2 className="text-6xl font-medium text-[#000000] mb-6 leading-tight">
              Real-time private company
              <br className="hidden sm:block" />
              data & research with
              <br className="hidden sm:block" />
              Polaris AI Portal™
            </h2>
            <p className="w-[50%] mx-auto text-center text-lg text-[#676767] leading-relaxed">
              Polaris Market‑data provides best‑in‑class price estimates and research for actively traded pre‑IPO companies
            </p>
            <div className="max-w-5xl mx-auto">
              <div className="max-w-5xl mx-auto flex items-end justify-center gap-6">
                <img src={portalPic} alt="Portal Preview" className="object-cover" />
              </div>
            </div>
          </div>
        </motion.section>

        {/* 数据聚合 */}
        <motion.section ref={ref2} initial={startStyle} animate={isRef2InView?endStyle:{}} transition={animationTransition} className="pt-20 bg-white">
          <div className="mx-auto">
            {/* 顶部合成图 */}
            <div className="rounded-2xl bg-[#0000000A] p-6 sm:p-8 mb-8">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="leading-tight font-medium text-4xl" style={{
                    background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    color: 'transparent'
                  }}>Primary round details and secondary <br/> market data, all in one place</h3>
                  <p className="text-[#676767] text-base mt-3 max-w-2xl">Achieve your financial dreams with our comprehensive financial planning <br/> services, guiding you toward a secure future.</p>
                </div>
                <div className="relative">
                  <img src={logo1Pic} alt="" />
                </div>
              </div>
              {/* captions under three preview cards */}
              <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div className="space-y-1">
                  <div className="relative">
                    <img src={primary1Pic} alt="Portal Preview" />
                    <div className="absolute bottom-[0px] h-[100px] w-[100%] bg-[#D9D2FF]" style={{
                      background:
                          'linear-gradient(180deg, rgba(248, 248, 248, 0) 37.02%, rgba(248, 248, 248, 0.707692) 70.67%, #F8F8F8 93.75%)',
                    }} />
                  </div>
                  <div className="text-md font-semibold text-[#000000]">Funding Rounds</div>
                  <div className="w-[80%] text-base text-[#424242] leading-relaxed break-words">Primary round investment history and filings</div>
                </div>
                <div className="space-y-1">
                  <div className="relative">
                    <div className="relative">
                      <img src={primary1Pic} alt="Portal Preview" />
                      <div className="absolute bottom-[0px] h-[100px] w-[100%] bg-[#D9D2FF]" style={{
                        background:
                            'linear-gradient(180deg, rgba(248, 248, 248, 0) 37.02%, rgba(248, 248, 248, 0.707692) 70.67%, #F8F8F8 93.75%)',
                      }} />
                    </div>
                  </div>
                  <div className="text-md font-semibold text-[#000000]">Investors</div>
                  <div className="w-[80%] text-base text-[#424242] leading-relaxed break-words">Explore private company investors, including their investment prices & dates</div>
                </div>
                <div className="space-y-1">
                  <div className="relative">
                    <img src={primary1Pic} alt="Portal Preview" />
                    <div className="absolute bottom-[0px] h-[100px] w-[100%] bg-[#D9D2FF]" style={{
                      background:
                          'linear-gradient(180deg, rgba(248, 248, 248, 0) 37.02%, rgba(248, 248, 248, 0.707692) 70.67%, #F8F8F8 93.75%)',
                    }} />
                  </div>
                  <div className="text-md font-semibold text-[#000000]">Transaction History</div>
                  <div className="w-[80%] text-base text-[#424242] leading-relaxed break-words">Over 3 years of secondary closed transaction data</div>
                </div>
              </div>
            </div>

            {/* 下方分解图布局 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* 左侧 Top Movers 列表 */}
              <div className="relative rounded-2xl max-h-[936px] bg-[#0000000A] p-8">
                <div className="flex items-start justify-between mb-2">
                  <h4 className="leading-tight font-medium text-4xl" style={{
                    background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    color: 'transparent'
                  }}>Top Movers</h4>
                  <div className="relative">
                    <img src={logo1Pic} alt="" />
                  </div>
                </div>
                <p className="text-[#676767] text-base max-w-2xl">Top gainers and losers across late-stage private companies</p>
                <div className="space-y-4 mt-4 overflow-y-auto " style={{ height: 'calc(100% - 115px)',
                  // 隐藏滚动条但仍保持滚动功能
                  msOverflowStyle: 'none',  /* IE and Edge */
                  scrollbarWidth: 'none'   /* Firefox */
                }}>
                  <div style={{
                    /* 隐藏webkit浏览器滚动条 */
                    WebkitOverflowScrolling: 'touch'
                  } as React.CSSProperties}>
                    {/* Item 1 */}
                    <div className="rounded-xl bg-white p-4 mb-3">
                      <div className="flex items-center mb-3">
                        <div className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center mr-3 overflow-hidden">
                          <img src={figurePic} alt="Figure AI" className="w-7 h-7 object-contain" />
                        </div>
                        <div className="text-xl text-[#121212]">Figure AI</div>
                      </div>
                      <div className="grid grid-cols-2 gap-3 text-sm">
                        <div>
                          <div className="text-md text-[#676767]">$ Change</div>
                          <div className="text-[#E2574C] text-lg">$280.4 ↓</div>
                        </div>
                        <div>
                          <div className="text-md text-[#676767]">$ Change</div>
                          <div className="text-[#E2574C] text-lg">66% ↓</div>
                        </div>
                        <div>
                          <div className="text-md text-[#676767]">Price Per Share</div>
                          <div className="text-[#121212] text-base">$18.40</div>
                        </div>
                        <div>
                          <div className="text-md text-[#676767]">Valuation</div>
                          <div className="text-[#121212] text-base">$14.46B</div>
                        </div>
                      </div>
                    </div>
                    {
                      [1,2,3].map((item) => (
                          <div key={item} className="rounded-xl bg-white p-4 mb-3">
                            <div className="flex items-center mb-3">
                              <div className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center mr-3 overflow-hidden">
                                <img src={figurePic} alt="Figure AI" className="w-7 h-7 object-contain" />
                              </div>
                              <div className="text-xl text-[#2B2B2B]">Scale AI</div>
                            </div>
                            <div key={ item } className="grid grid-cols-2 gap-3 text-sm">
                              <div>
                                <div className="text-md text-[#676767]">$ Change</div>
                                <div className="text-[#4FE74F] text-lg">$280.4 ↑</div>
                              </div>
                              <div>
                                <div className="text-md text-[#676767]">$ Change</div>
                                <div className="text-[#4FE74F] text-lg">66% ↑</div>
                              </div>
                              <div>
                                <div className="text-md text-[#676767]">Price Per Share</div>
                                <div className="text-[#121212] text-base">$18.40</div>
                              </div>
                              <div>
                                <div className="text-md text-[#676767]">Valuation</div>
                                <div className="text-[#121212] text-base">$14.46B</div>
                              </div>
                            </div>
                          </div>
                      ))
                    }
                  </div>
                </div>
              </div>

              <div className="md:col-span-2">
                <div className="rounded-2xl bg-[#0000000A] p-6 mb-2">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="leading-tight font-medium text-4xl" style={{
                      background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      color: 'transparent'
                    }}>Institutional Investors</h4>
                    <div className="relative">
                      <img src={logo1Pic} alt="" />
                    </div>
                  </div>
                  <p className="text-[#676767] text-base max-w-2xl">Monitor a range of private market investments with our platform and comprehensive data reporting.</p>
                  <div className="rounded-xl overflow-hidden mt-4">
                    <div className="relative">
                      <img src={primary2Pic} alt="Portal Preview" className="" />
                      <div className="absolute bottom-[0px] h-[100px] w-[100%] bg-[#D9D2FF]" style={{
                        background:
                            'linear-gradient(180deg, rgba(248, 248, 248, 0) 37.02%, rgba(248, 248, 248, 0.707692) 70.67%, #F8F8F8 93.75%)',
                      }} />
                    </div>

                  </div>
                </div>
                <div className="rounded-2xl bg-[#0000000A] p-6 mb-2">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="leading-tight font-medium text-4xl" style={{
                      background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      color: 'transparent'
                    }}>Sector and Market Insights for<br/> sophisticated investors</h4>
                    <div className="relative">
                      <img src={logo1Pic} alt="" />
                    </div>
                  </div>
                  <p className="text-[#676767] text-base max-w-2xl">Monitor a range of private market investments with our platform and comprehensive data reporting.</p>
                  <div className="rounded-xl overflow-hidden mt-4">
                    <div className="relative">
                      <img src={primary3Pic} alt="Portal Preview" className="" />
                      <div className="absolute bottom-[0px] h-[100px] w-[100%] bg-[#D9D2FF]" style={{
                        background:
                            'linear-gradient(180deg, rgba(248, 248, 248, 0) 37.02%, rgba(248, 248, 248, 0.707692) 70.67%, #F8F8F8 93.75%)',
                      }} />
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* 信任原因 */}
        <motion.section ref={ref3} initial={startStyle} animate={isRef3InView?endStyle:{}} transition={animationTransition} className="pt-10 bg-white relative">
          <div className="mx-auto">
            <div className="relative z-10 h-[725px] grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* 左侧文案 */}
              <div className="my-auto">
                <p className="text-[#6E66E1] text-md font-semibold uppercase tracking-wide mb-2">BACKED BY EXPERIENCE</p>
                <h2 className="leading-tight font-medium text-6xl text-[#121212]">
                  Why leading firms
                  <br className="hidden lg:block" />
                  trust us for private
                  <br className="hidden lg:block" />
                  market access
                </h2>
                <p className="text-lg text-[#676767] mb-8 leading-relaxed w-[80%]">
                  Navigating private markets is complex. We make it simple, scalable, and systematic. Invest with Polaris trusted by 100+ financial firms, with a proven track record of 130+ successful transactions.
                </p>
              </div>
              <div className="my-auto ml-10 w-[60%]">
                {/* 定位到右下角的卡片 */}
                <div className="">
                  {/* 卡片 1 */}
                  <div className="bg-white/90 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-5 mb-4">
                    <div>
                      <div className="flex items-center justify-start">
                        <img
                            src={superiorNetworkPic}
                            alt=""
                            className="mr-5"
                        />
                        <div className="text-lg font-semibold text-[#121212CC]">Superior Network</div>
                      </div>
                      <div className="text-sm text-[#12121280] mt-2 leading-snug">Proprietary deal flow across a fragmented, in‑transparent & inefficient secondary market</div>
                    </div>
                  </div>

                  {/* 卡片 2 */}
                  <div className="bg-white/90 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-5 mb-4">
                    <div>
                      <div className="flex items-center justify-start">
                        <img
                            src={efficientStructurePic}
                            alt=""
                            className="mr-5"
                        />
                        <div className="text-lg font-semibold text-[#121212CC]">Efficient Structure</div>
                      </div>
                      <div className="text-sm text-[#12121280] mt-2 leading-snug">Capability to aggregate investor demand across structures, co‑investments, and client types</div>
                    </div>
                  </div>

                  {/* 卡片 3 */}
                  <div className="bg-white/90 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-5">
                    <div>
                      <div className="flex items-center justify-start">
                        <img
                            src={executionExpertisePic}
                            alt=""
                            className="mr-5"
                        />
                        <div className="text-lg font-semibold text-[#121212CC]">Execution Expertise</div>
                      </div>
                      <div className="text-sm text-[#12121280] mt-2 leading-snug">Investment committee with 15+ years experience and 100+ investment conducted</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 定位到整个信任原因部分右下角的图片 */}
          <div className="absolute bottom-10 right-0">
            <img
                src={privateMarketAccessPic}
                alt=""
                className="object-cover"
            />
          </div>
        </motion.section>

        {/* 客户评价 */}
        <motion.section ref={ref4} initial={startStyle} animate={isRef4InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white overflow-hidden">
          <div className="mx-auto">
            <h2 className="leading-tight font-medium text-6xl text-[#121212]">
              What our investors
              <br className="hidden sm:block" />
              say about us
            </h2>

            {/* Slider-like row */}
            <div className="mt-10 relative flex items-start space-x-3">
              {/* Arrows */}
              <div className="flex items-center space-x-3 z-10">
                <button className="w-10 h-10 rounded-full bg-[#F6F6F9] text-gray-600 hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center hover:scale-110 hover:shadow-lg group">
                  <span className="sr-only">Previous</span>
                  <img
                      src={leftPic}
                      alt=""
                      className="transition-all duration-300 ease-in-out group-hover:brightness-0 group-hover:invert"
                  />
                </button>
                <button className="w-10 h-10 rounded-full bg-[#F6F6F9] text-gray-600 hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center hover:scale-110 hover:shadow-lg group">
                  <span className="sr-only">Next</span>
                  <img
                      src={rightPic}
                      alt=""
                      className="transition-all duration-300 ease-in-out group-hover:brightness-0 group-hover:invert"
                  />
                </button>
              </div>

              {/* Cards row */}
              <div className="flex gap-6">
                {/* Active card */}
                {[1,2,3].map((item) => (
                    <div key={item} className="w-[586px] bg-white border border-gray-200 rounded-2xl p-12 shadow-sm" style={{opacity: 1/item}}>
                      <blockquote className="text-[#676767] text-xl leading-7 mb-8">
                        “Lorem ipsum dolor sit amet, consectetur adipiscing elit. In commodo dolor fermentum dignissim et pellentesque egestas mauris, faucibus. Tellus nisi amet non at phasellus faucibus senectus in”
                      </blockquote>
                      <div className="flex items-center">
                        <img src={headerPic} alt="avatar" className="w-11 h-11 rounded-full object-cover mr-3" />
                        <div>
                          <div className="text-[#676767] font-semibold text-sm">JOHN CARTER</div>
                          <div className="text-[#676767] text-xs tracking-wide">ROLE, COMPANY</div>
                        </div>
                      </div>
                    </div>
                ))}
              </div>
            </div>
          </div>
        </motion.section>

        {/* 增长潜力行动号召 */}
        <motion.section ref={ref5} initial={startStyle} animate={isRef5InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white">
          <div className="mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center ">
              {/* 左侧说明 */}
              <div className="lg:col-span-2">
                <p className="text-[#6E66E1] text-md font-semibold uppercase tracking-wide mb-2">EXCLUSIVE REPORTS</p>
                <h2 className="text-6xl font-medium text-[#121212CC] font-bold mb-4 leading-tight">
                  Unlock growth potential
                  <br className="hidden sm:block" />
                  in Private Markets
                </h2>
                <p className="text-lg text-[#676767] mb-8 leading-relaxed w-[60%]">
                  Learn how investing in unicorns can provide liquidity, portfolio flexibility, and access to the Top 20 most valuable companies before their IPO. Sign up to receive an exclusive white paper on the VC and pre‑IPO secondaries market.
                </p>
              </div>

              {/* 右侧订阅卡片 */}
              <div className="lg:col-span-1 w-full flex justify-start lg:justify-end">
                <div className="w-full max-w-md bg-[#F8F8F8] rounded-2xl p-6 shadow-sm">
                  {/* 顶部小星星 */}
                  <div className="w-8 h-8 mx-auto mb-6 text-[#6E66E1] flex items-center justify-center">
                    <img src={logo3Pic} alt="" />
                  </div>

                  <form className="space-y-4">
                    <input type="text" placeholder="First Name" className="w-full px-4 py-3 rounded-full border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none" />
                    <input type="text" placeholder="Last Name" className="w-full px-4 py-3 rounded-full border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none" />
                    <input type="email" placeholder="Email" className="w-full px-4 py-3 rounded-full border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none" />

                    <div className="flex items-start space-x-3">
                      <input id="consent" type="radio" className="mt-1 h-4 w-4 text-[#F8F8F8] border-gray-300 rounded cursor-pointer" style={{
                        accentColor: '#6B5AE6',
                        '--tw-ring-color': '#6B5AE6'
                      } as React.CSSProperties} />
                      <label htmlFor="consent" className="text-[12px] text-gray-600 leading-relaxed">
                        I accept Polaris' Privacy Policy to receive the guide and marketing info on growth equity and pre‑IPO investments. I consent to Personal Data processing for relevant updates. I confirm I've read and accept the Disclaimer. I can opt out anytime.
                      </label>
                    </div>

                    <button type="submit" className="w-full h-11 rounded-full bg-[#6E66E1] text-white text-sm font-medium hover:bg-[#5c4fd6] transition-all duration-300 ease-in-out inline-flex items-center justify-center active:scale-95 group">
                      Subscribe <svg className="w-4 h-4 ml-2 text-white transform transition-all duration-300 ease-in-out group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* 投资行动号召 */}
        <motion.section
            ref={ref6} initial={startStyle} animate={isRef6InView?endStyle:{}} transition={animationTransition}
            className="py-24 text-center rounded-t-xl"
            style={{
              background:
                  'linear-gradient(180deg, #6E66E1 0%, rgba(139, 124, 244, 0.8) 52.39%, rgba(165, 180, 238, 0.347222) 83.65%, rgba(178, 210, 234, 0) 100%)',
            }}
        >
          <div className="max-w-5xl mx-auto">
            <h2 className="text-6xl font-medium text-white mb-6 leading-tight">
              Ready to Invest in Private
              <br className="hidden sm:block" />
              Technology Leaders?
            </h2>
            <p className="text-white/80 text-lg mb-8">Explore how Polaris can enhance your portfolio today.</p>
            <button className="inline-flex items-center justify-center h-11 px-6 rounded-full bg-white text-[#6B5AE6] text-sm border border-white/60 font-medium shadow-sm hover:bg-white/95 transition-all duration-300 ease-in-out active:scale-95 group">
              Contact Us <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
            </svg>
            </button>
          </div>
        </motion.section>

        {/* 新闻与洞察 */}
        <motion.section ref={ref7} initial={startStyle} animate={isRef7InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white">
          <div className="mx-auto">
            <div className="flex justify-between items-center mb-12">
              <h2 className="text-6xl font-medium text-gray-800 mb-6 leading-tight">News & Insights</h2>
              <div className="bg-gray-100 flex item-center rounded-full text-gray-700 px-6 py-2 font-medium hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out group">
                <a href="#" className="text-[#12121280] text-sm font-medium inline-flex items-center group-hover:text-white transition-colors duration-300">
                  View All <svg className="w-4 h-4 ml-2 text-[#12121280] transform transition-all duration-300 ease-in-out group-hover:text-white group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                </svg>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              <div className="w-[400px] bg-white overflow-hidden flex flex-col">
                <div className="">
                  <img
                      src={newsImgPic}
                      alt=""
                      className=""
                  />
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="text-lg font-medium text-black mb-3" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    Polaris partners with X to expand access to global high-growth pre-IPO investments
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out hover:scale-105">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform rotate-45 transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-[400px] bg-white overflow-hidden flex flex-col">
                <div className="">
                  <img
                      src={newsImgPic}
                      alt=""
                      className=""
                  />
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="text-lg font-medium text-black mb-3" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    The future of private market investing: AI-powered insights and data-driven decisions The future of private market investing: AI-powered insights and data-driven decisionsThe future of private market investing: AI-powered insights and data-driven decisions
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out hover:scale-105">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform rotate-45 transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-[400px] bg-white overflow-hidden flex flex-col">
                <div className="">
                  <img
                      src={newsImgPic}
                      alt=""
                      className=""
                  />
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="text-lg font-medium text-black mb-3" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    Polaris 20 Fund achieves record returns in challenging market conditions
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out hover:scale-105">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform rotate-45 transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

      </div>
  );
}
